import type { IOfficeConsentContent } from '../types/OfficeConsentContent';
import type { IOfficeConsentContentApi } from '../types/OfficeConsentContent.api';

function toOfficeConsentContent(apiResponse: IOfficeConsentContentApi): IOfficeConsentContent {
  return {
    code: apiResponse.code,
    officeId: apiResponse.office_id,
    isConsented: apiResponse.is_consented,
    header: apiResponse.header,
    body: apiResponse.body,
    consentedRequirements: apiResponse.consented_requirements.map((r) => ({
      key: r.key,
      value: r.value,
      expiredAt: r.expired_at,
      url: r.url,
    })),
    notConsentedRequirements: apiResponse.not_consented_requirements.map((r) => ({
      key: r.key,
      value: r.value,
      expiredAt: r.expired_at,
      url: r.url,
    })),
  };
}

export const OfficeConsentContentAdapter = {
  toOfficeConsentContent,
};
